module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("9epHz"))).then(() => parcelRequire('37nVf'));